import React from 'react';

import { RateSliderGroup } from './RateSliderGroup';

interface TierSliderRowProps {
	tierName: string;
	rateValue: number;
	feeValue: number;
	onRateChange: (value: number) => void;
	onFeeChange: (value: number) => void;
	showReadOnly?: boolean;
	className?: string;
}

export const TierSliderRow: React.FC<TierSliderRowProps> = ({
	tierName,
	rateValue,
	feeValue,
	onRateChange,
	onFeeChange,
	showReadOnly = false,
	className = 'grid grid-cols-5 gap-6 items-center',
}) => {
	return (
		<div className={className}>
			<div className="font-medium text-gray-900 col-span-1">{tierName}</div>
			<RateSliderGroup
				rateValue={rateValue}
				feeValue={feeValue}
				onRateChange={onRateChange}
				onFeeChange={onFeeChange}
				showReadOnly={showReadOnly}
			/>
		</div>
	);
};
